import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { TokenService } from './services/token.service';
import { AuthService } from './services/auth.service';

// adding global namespace for Google Analytics window.ga
declare global {
  interface Window { ga: any; }
}

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
  loadedUser: boolean = true;
  _subscription;

  constructor(
    private router: Router,
    private auth: AuthService,
    private tokenService: TokenService
  ) {
    // subscribed to changes in user
    this._subscription = tokenService.currentUserChange.subscribe((user) => {
      if (user) {
        this.loadedUser = true;
      } else {
        this.router.navigate(['login']);
      }
    });
  }

  ngOnInit() {
    this.router.events.filter(event => event instanceof NavigationEnd)
    .subscribe(event => {
      document.getElementById('top').scrollIntoView();
    });
    this.auth.getAuth();
  }

  ngOnDestroy() {
    this._subscription.unsubscribe();
  }
}



// WEBPACK FOOTER //
// /Users/iangoldfarb/Desktop/SupplyHub/shFrontEnd/src/app/app.component.ts